<template>
  <address v-if="order.customer !== null">
    <span
      v-if="
        order.customer.firstName &&
        order.customer.lastName
      "
    >
      {{ order.customer.firstName }} {{ order.customer.lastName }},<br />
    </span>
    <span v-if="order.customer.address.houseNameNumber">
      {{ order.customer.address.houseNameNumber }},<br />
    </span>    
    <span v-if="order.customer.address.addressLine1">
      {{ order.customer.address.addressLine1 }},<br />
    </span>
    <span v-if="order.customer.address.addressLine2">
      {{ order.customer.address.addressLine2 }},<br />
    </span>
    <span v-if="order.customer.address.townCity">
      {{ order.customer.address.townCity }},<br />
    </span>
    <span v-if="order.customer.address.postcodeZip">
    {{ order.customer.address.postcodeZip }}<br />
    </span>
  </address>
</template>

<script>
export default {
  name: 'CustomerAddress',
  props: ['order']
}
</script>
